<template>
  <div id="app">
    <navbar v-if="this.$store.state.auth.user" />
    <div style="margin-bottom: -0.75rem" class="columns">
      <sidebar v-if="isSidebarVisibible" class="column is-2" />
      <div style="padding-bottom: 0;padding-right:0" class="column">
        <router-view :key="$route.fullPath" />
      </div>
      <searchbar v-if="$store.state.search.displaySearchBar" />
    </div>

    <div v-if="$store.state.auth.user && canEnableMentorChat()">
      <MentorChat></MentorChat>
    </div>
    <Loader :show="$store.state.loader.running" :text="$store.state.loader.text"></Loader>
  </div>
</template>

<script>
import Navbar from "./components/layout/Navbar.vue";
import Loader from "./components/Loader.vue";
import Sidebar from "./components/layout/Sidebar.vue";
import MentorChat from "./components/globals/MentorChat";
import SearchSideBar from "./components/layout/SearchSideBar";
export default {
  name: "App",
  components: {
    Navbar,
    Loader,
    Sidebar,
    MentorChat,
    searchbar: SearchSideBar
  },
  computed: {
    isSidebarVisibible: function() {
      if (
        this.$store.state.auth.user &&
        this.$route.name != "courses" &&
        this.$route.name != "canvas.index" &&
        this.$route.name != "canvas.view" &&
        this.$route.name != "login"
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    canEnableMentorChat() {
      if (
        this.$route.name == "chat" ||
        this.$route.name == "chat.channel" ||
        this.$route.name == "canvas.index" ||
        this.$route.name == "canvas.view"
      ) {
        return false;
      }
      return true;
    }
  }
};
</script>


<style>
@import "assets/scss/app.scss";
</style>